<template>
  <div v-if="this.isManager('finance')" class="hidden-md-and-down">
    <el-button v-if="(isManager() && !rowData.paid) || isSuper()" icon="fa fa-trash-alt" @click="deleteEntry()" size="small" type="danger" circle></el-button>
    </div>
  </template>

  <script>
  import {settings} from '@/components/Data'
  import PostMixins from '@/mixins/PostMixins'

  export default {
    mixins: [PostMixins],

    props: {
      rowData: {
        type: Object,
        required: true
      },
      tableRef: {
        type: String,
        default: 'utiltable'
      }
    },

    methods: {
      deleteEntry () {
        this.deleteItem(this, this.rowData.id, '/utility', this.rowData.invoiceNo + ' - ' + settings.currency + this.rowData.total, this.onDelete)
      },
      onDelete (response) {
        this.$events.fire(this.tableRef + '-refresh-table')
      }
    }
  }
  </script>

  <style>
  .item {
    margin-top: 10px;
    margin-right: 40px;
  }
  </style>



// WEBPACK FOOTER //
// UtilityControls.vue?2bb48d14